import React, {useState, useId} from 'react';
import {Form, Collapse, Divider} from "antd";
import {ChevronRightRounded} from "@mui/icons-material";
import Button from "./Button";

const TableFilterControlsForm = ({ useApplyButton = false, useResetButton = false, customButton, children, additionalFilterSections = [], ...rest }) => {
    const id = useId();
    const [activeKey, setActiveKey] = useState(null);
    const [isOpen, setOpen] = useState(false);

    const handleButtonClick = () => {
        if(activeKey) {
            setActiveKey(null);
            setOpen(false);
        } else {
            setActiveKey("1");
            setOpen(true);
        }
    };

    const filterItems = [
        {
            key: '1',
            label: 'Additional Filters',
            forceRender:true,
            children: (
                <div
                    id={"filter-sections-content"+id}
                    role="region"
                    aria-labelledby={"filter-sections-button"+id}
                    className={'ch-filter-form ch-filter-form-nested'}
                >
                    <div className={'ch-filter-form-content'}>
                        {additionalFilterSections}
                    </div>
                </div>
            ),
        }
    ];

    const hasButtons = useResetButton || useApplyButton || customButton || additionalFilterSections.length > 0;

    return (
        <Form
            layout={'vertical'}
            {...rest}
            className={'ch-form ch-filter-form'}
        >
            <div className={'ch-filter-form-content'}>
                {children}
                {isOpen && <Divider style={{margin: "12px 0 4px 0"}}/>}
                {additionalFilterSections.length > 0 &&
                    <Collapse activeKey={activeKey} accordion ghost items={filterItems} size={"small"} className={'ch-table-filter-collapse-nostyle'} />
                }
            </div>
            {hasButtons &&
                <div className={'ch-filter-form-buttons'}>
                    {useResetButton &&
                        <Button type="outline">
                            Reset Filter
                        </Button>
                    }
                    {useApplyButton &&
                        <Button type="primary" htmlType="submit">
                            Apply Filter
                        </Button>
                    }
                    {customButton}
                    {additionalFilterSections.length > 0 &&
                        <Button
                            id={'filter-sections-button'+id}
                            aria-controls={'filter-sections-content'+id}
                            aria-expanded={isOpen}
                            type={'outline'}
                            onClick={handleButtonClick}
                        >
                            <span className={'ch-filter-form-button-content'}>
                                {isOpen ? 'Less' : 'More'} Filters
                                <ChevronRightRounded
                                    style={{
                                        transform: isOpen ? 'rotate(270deg)' : 'rotate(90deg)',
                                        transition:'var(--ani-mid) ease'}}
                                />
                            </span>
                        </Button>
                    }
                </div>
            }
        </Form>
    );
};

export default TableFilterControlsForm;